import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";

const DialogConfirmarAtendimento = ({ 
  visible, 
  onHide, 
  onConfirm, 
  message = "Agendamento realizado com sucesso!",
  question = "Deseja iniciar o atendimento agora?"
}) => {
  return (
    <Dialog
      visible={visible}
      style={{ width: "350px", fontFamily: "'Rajdhani', sans-serif" }}
      onHide={onHide}
      draggable={false}
      closable={false}
      header={null}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "20px",
          padding: "10px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "25px",
            height: "25px",
            borderRadius: "50%",
            color: "#22C55E",
            fontSize: "2.2rem",
          }}
        >
          <i className="pi pi-check-circle" style={{ fontSize: "2.5rem" }}></i>
        </div>
        <p
          style={{
            textAlign: "center",
            fontSize: "1rem",
            margin: 0,
            color: "#374151",
            fontWeight: "500",
          }}
        >
          {message}
        </p>
        <p
          style={{
            textAlign: "center",
            fontSize: "0.95rem",
            margin: "-10px 0 0 0",
            color: "#6c757d",
          }}
        >
          {question}
        </p>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "12px",
            width: "100%",
          }}
        >
          <Button
            label="NÃO"
            icon="pi pi-times"
            onClick={onHide}
            className="p-button-outlined p-button-sm"
            style={{
              outline: "none",
              boxShadow: "none",
              padding: "8px 24px",
              minWidth: "100px",
              borderColor: "#dee2e6",
              color: "#495057",
              fontWeight: "500",
              fontSize: "0.875rem",
            }}
          />
          <Button
            label="SIM"
            icon="pi pi-check"
            onClick={onConfirm}
            className="p-button-success p-button-sm"
            style={{
              outline: "none",
              boxShadow: "none",
              padding: "8px 24px",
              minWidth: "100px",
              fontWeight: "500",
              fontSize: "0.875rem",
              backgroundColor: "#28a745",
              borderColor: "#28a745",
            }}
          />
        </div>
      </div>
    </Dialog>
  );
};

export default DialogConfirmarAtendimento;